import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@pwc/appkit-react/lib/Banner';
import { Button } from '@pwc/appkit-react/lib/Button';

const DONT_SHOW_LAST_SECONDS = 5;

const formatTimeDistance = timeDistance => timeDistance ? `${timeDistance.toFixed(0)}s` : '';

const SessionExpirationBanner = ({ refreshSession, timeDistance, disableRefresh }) => {
  const warningMessage = (
    <>
      {timeDistance < DONT_SHOW_LAST_SECONDS
        ? `Your session is about to expire`
        : `Your session will expire in ${formatTimeDistance(timeDistance)}`}
      <Button className="banner-button" onClick={refreshSession} disabled={disableRefresh}>Refresh</Button>
    </>
  );

  return (
    <div className="session-warning-banner">
      <Banner status="warning" content={warningMessage} />
    </div>
  );
};

SessionExpirationBanner.propTypes = {
  refreshSession: PropTypes.func,
  timeDistance: PropTypes.number.isRequired,
  disableRefresh: PropTypes.bool,
};

export default SessionExpirationBanner;
